export const CommonMessage = {
    errorMessageBackend: "Lỗi xảy ra vui lòng liên hệ admin để xử lý.",
    tokenHasExpired: "Phiên đăng nhập đã hết hạn."
}